{
  "en-US": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-GB": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-AU": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-CA": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-IE": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-NZ": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "en-ZA": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germany"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Netherlands"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "South Africa"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "South Korea"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spain"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "US",
      "value": "US",
      "label": "United States"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "de-DE": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinien"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dänemark"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Deutschland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankreich"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griechenland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbien"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Neuseeland"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Niederlande"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegen"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Österreich"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumänien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russland"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Schweden"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakei"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slowenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Südafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Südkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tschechien"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkei"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Vereinigte Staaten"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Vereinigtes Königreich"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Zypern"
    }
  ],
  "de-AT": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinien"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dänemark"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Deutschland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankreich"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griechenland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbien"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Neuseeland"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Niederlande"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegen"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Österreich"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumänien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russland"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Schweden"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakei"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slowenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Südafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Südkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tschechien"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkei"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Vereinigte Staaten"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Vereinigtes Königreich"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Zypern"
    }
  ],
  "de-BE": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinien"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dänemark"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Deutschland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankreich"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griechenland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbien"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Neuseeland"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Niederlande"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegen"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Österreich"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumänien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russland"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Schweden"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakei"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slowenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Südafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Südkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tschechien"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkei"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Vereinigte Staaten"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Vereinigtes Königreich"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Zypern"
    }
  ],
  "de-LU": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinien"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dänemark"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Deutschland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankreich"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griechenland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbien"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Neuseeland"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Niederlande"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegen"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Österreich"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumänien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russland"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Schweden"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakei"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slowenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Südafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Südkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tschechien"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkei"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Vereinigte Staaten"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Vereinigtes Königreich"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Zypern"
    }
  ],
  "es-ES": [
    {
      "id": "DE",
      "value": "DE",
      "label": "Alemania"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bélgica"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canadá"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Chequia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chipre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corea del Sur"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croacia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dinamarca"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Eslovaquia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Eslovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "España"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Estados Unidos"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francia"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungría"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japón"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malasia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "México"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noruega"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nueva Zelanda"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Países Bajos"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Reino Unido"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumanía"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sudáfrica"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suecia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquía"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucrania"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "es-AR": [
    {
      "id": "DE",
      "value": "DE",
      "label": "Alemania"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bélgica"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canadá"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Chequia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chipre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corea del Sur"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croacia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dinamarca"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Eslovaquia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Eslovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "España"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Estados Unidos"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francia"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungría"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japón"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malasia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "México"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noruega"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nueva Zelanda"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Países Bajos"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Reino Unido"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sudáfrica"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suecia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquía"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucrania"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "es-MX": [
    {
      "id": "DE",
      "value": "DE",
      "label": "Alemania"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bélgica"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canadá"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Chequia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chipre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corea del Sur"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croacia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dinamarca"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Eslovaquia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Eslovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "España"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Estados Unidos"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francia"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungría"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japón"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malasia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "México"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noruega"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nueva Zelanda"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Países Bajos"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Reino Unido"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sudáfrica"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suecia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquía"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucrania"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "fr-FR": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrique du Sud"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Allemagne"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentine"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australie"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Autriche"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgique"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brésil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarie"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Chine"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chypre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombie"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corée du Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatie"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danemark"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espagne"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonie"
    },
    {
      "id": "US",
      "value": "US",
      "label": "États-Unis"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlande"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grèce"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongrie"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Inde"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésie"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlande"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islande"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italie"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japon"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonie"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituanie"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaisie"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malte"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexique"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvège"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nouvelle-Zélande"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Pays-Bas"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Pologne"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roumanie"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Royaume-Uni"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russie"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovaquie"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovénie"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suède"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tchéquie"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaïlande"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquie"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Viêt Nam"
    }
  ],
  "fr-BE": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrique du Sud"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Allemagne"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentine"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australie"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Autriche"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgique"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brésil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarie"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Chine"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chypre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombie"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corée du Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatie"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danemark"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espagne"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonie"
    },
    {
      "id": "US",
      "value": "US",
      "label": "États-Unis"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlande"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grèce"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongrie"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Inde"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésie"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlande"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islande"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italie"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japon"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonie"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituanie"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaisie"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malte"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexique"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvège"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nouvelle-Zélande"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Pays-Bas"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Pologne"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roumanie"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Royaume-Uni"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russie"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovaquie"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovénie"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suède"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tchéquie"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaïlande"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquie"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Viêt Nam"
    }
  ],
  "fr-CA": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrique du Sud"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Allemagne"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentine"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australie"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Autriche"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgique"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brésil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarie"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Chine"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chypre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombie"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corée du Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatie"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danemark"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espagne"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonie"
    },
    {
      "id": "US",
      "value": "US",
      "label": "États-Unis"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlande"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grèce"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongrie"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Inde"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésie"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlande"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islande"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italie"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japon"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonie"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituanie"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaisie"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malte"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexique"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvège"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nouvelle-Zélande"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Pays-Bas"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Pologne"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roumanie"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Royaume-Uni"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russie"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovaquie"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovénie"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suède"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tchéquie"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaïlande"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquie"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "fr-LU": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrique du Sud"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Allemagne"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentine"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australie"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Autriche"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgique"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brésil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarie"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Chine"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chypre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombie"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corée du Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatie"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danemark"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espagne"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonie"
    },
    {
      "id": "US",
      "value": "US",
      "label": "États-Unis"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlande"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "France"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grèce"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongrie"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Inde"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésie"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlande"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islande"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italie"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japon"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonie"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituanie"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaisie"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malte"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexique"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvège"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nouvelle-Zélande"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Pays-Bas"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Pologne"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roumanie"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Royaume-Uni"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russie"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovaquie"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovénie"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suède"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tchéquie"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaïlande"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquie"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Viêt Nam"
    }
  ],
  "it-IT": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgio"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasile"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Cechia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Cile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Cina"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cipro"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corea del Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croazia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danimarca"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francia"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germania"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Giappone"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islanda"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Lussemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Messico"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvegia"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nuova Zelanda"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Paesi Bassi"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portogallo"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Regno Unito"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovacchia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spagna"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Stati Uniti"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sudafrica"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Svezia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turchia"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungheria"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "it-MT": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgio"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasile"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Cechia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Cile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Cina"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cipro"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Corea del Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croazia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danimarca"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francia"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germania"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Giappone"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islanda"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Lussemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Messico"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvegia"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nuova Zelanda"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Paesi Bassi"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portogallo"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Regno Unito"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovacchia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spagna"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Stati Uniti"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sudafrica"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Svezia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turchia"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungheria"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "ja-JP": [
    {
      "id": "IS",
      "value": "IS",
      "label": "アイスランド"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "アイルランド"
    },
    {
      "id": "US",
      "value": "US",
      "label": "アメリカ合衆国"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "アルゼンチン"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "イギリス"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "イタリア"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "インド"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "インドネシア"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "ウクライナ"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "エストニア"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "オーストラリア"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "オーストリア"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "オランダ"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "カナダ"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "キプロス"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "ギリシャ"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "クロアチア"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "コロンビア"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "スウェーデン"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "スペイン"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "スロバキア"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "スロベニア"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "タイ"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "チェコ"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "チリ"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "デンマーク"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "ドイツ"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "トルコ"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "ニュージーランド"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "ノルウェー"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "ハンガリー"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "フィンランド"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "ブラジル"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "フランス"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "ブルガリア"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "ベトナム"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "ベルギー"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "ポーランド"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "ポルトガル"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "マルタ"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "マレーシア"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "メキシコ"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "ラトビア"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "リトアニア"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "ルーマニア"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "ルクセンブルク"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "ロシア"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "韓国"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "中国"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "南アフリカ"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "日本"
    }
  ],
  "nl-NL": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinië"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australië"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "België"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazilië"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarije"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denemarken"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Duitsland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankrijk"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griekenland"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongarije"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ierland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "IJsland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesië"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italië"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatië"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litouwen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Maleisië"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nederland"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nieuw-Zeeland"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noorwegen"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Oekraïne"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Oostenrijk"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roemenië"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusland"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenië"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakije"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanje"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tsjechië"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkije"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Verenigd Koninkrijk"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Verenigde Staten"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Zuid-Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Zuid-Korea"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Zweden"
    }
  ],
  "nl-BE": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentinië"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australië"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "België"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazilië"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarije"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chili"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denemarken"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Duitsland"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankrijk"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Griekenland"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hongarije"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ierland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "IJsland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesië"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italië"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatië"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litouwen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Maleisië"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nederland"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nieuw-Zeeland"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noorwegen"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Oekraïne"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Oostenrijk"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roemenië"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusland"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenië"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slowakije"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanje"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tsjechië"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkije"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Verenigd Koninkrijk"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Verenigde Staten"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Zuid-Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Zuid-Korea"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Zweden"
    }
  ],
  "pt-BR": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "África do Sul"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Alemanha"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austrália"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Áustria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bélgica"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgária"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canadá"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chipre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colômbia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Coreia do Sul"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croácia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dinamarca"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Eslováquia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Eslovênia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espanha"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Estados Unidos"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estônia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlândia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "França"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grécia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungria"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Índia"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islândia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itália"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japão"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letônia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituânia"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malásia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "México"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noruega"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nova Zelândia"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Países Baixos"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polônia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Reino Unido"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romênia"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rússia"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suécia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailândia"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tchéquia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquia"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucrânia"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnã"
    }
  ],
  "pt-PT": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "África do Sul"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Alemanha"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austrália"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Áustria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bélgica"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgária"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canadá"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Chéquia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Chipre"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colômbia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Coreia do Sul"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croácia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dinamarca"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Eslováquia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Eslovénia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espanha"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Estados Unidos"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estónia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlândia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "França"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grécia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungria"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Índia"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islândia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itália"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japão"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letónia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituânia"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburgo"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malásia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "México"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noruega"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nova Zelândia"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Países Baixos"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polónia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Reino Unido"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Roménia"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rússia"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suécia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailândia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turquia"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucrânia"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietname"
    }
  ],
  "bg-BG": [
    {
      "id": "AU",
      "value": "AU",
      "label": "Австралия"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Австрия"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Аржентина"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Белгия"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Бразилия"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "България"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Виетнам"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Германия"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Гърция"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Дания"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Естония"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Индия"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Индонезия"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ирландия"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Исландия"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Испания"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Италия"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Канада"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Кипър"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Китай"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Колумбия"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Латвия"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Литва"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Люксембург"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Малайзия"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Малта"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Мексико"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Нидерландия"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Нова Зеландия"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Норвегия"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Обединеното кралство"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Полша"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Португалия"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Румъния"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Русия"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Словакия"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Словения"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Съединени щати"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Тайланд"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Турция"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Украйна"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Унгария"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Финландия"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Франция"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Хърватия"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Чехия"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Чили"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Швеция"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Южна Африка"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Южна Корея"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Япония"
    }
  ],
  "cs-CZ": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austrálie"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgie"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazílie"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulharsko"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Česko"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Čína"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dánsko"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonsko"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finsko"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francie"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Chorvatsko"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indie"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonésie"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irsko"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itálie"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonsko"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Jihoafrická republika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Jižní Korea"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbie"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kypr"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litva"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lotyšsko"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Lucembursko"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Maďarsko"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malajsie"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Německo"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nizozemsko"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norsko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nový Zéland"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polsko"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalsko"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Rakousko"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumunsko"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusko"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Řecko"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovensko"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovinsko"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Spojené království"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Spojené státy"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Španělsko"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Švédsko"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thajsko"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turecko"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrajina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "da-DK": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cypern"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankrig"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grækenland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kina"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nederlandene"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norge"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumænien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusland"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakiet"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Storbritannien"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sverige"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sydafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Sydkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tjekkiet"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Tyrkiet"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Tyskland"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "USA"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Østrig"
    }
  ],
  "el-CY": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Αργεντινή"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Αυστραλία"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Αυστρία"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Βέλγιο"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Βιετνάμ"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Βουλγαρία"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Βραζιλία"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Γαλλία"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Γερμανία"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Δανία"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Ελλάδα"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Εσθονία"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Ηνωμένες Πολιτείες"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Ηνωμένο Βασίλειο"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Ιαπωνία"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Ινδία"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Ινδονησία"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ιρλανδία"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Ισλανδία"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Ισπανία"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Ιταλία"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Καναδάς"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Κάτω Χώρες"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Κίνα"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Κολομβία"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Κροατία"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Κύπρος"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Λετονία"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Λιθουανία"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Λουξεμβούργο"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Μαλαισία"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Μάλτα"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Μεξικό"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Νέα Ζηλανδία"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Νορβηγία"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Νότια Αφρική"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Νότια Κορέα"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ουγγαρία"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ουκρανία"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Πολωνία"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Πορτογαλία"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Ρουμανία"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Ρωσία"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Σλοβακία"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Σλοβενία"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Σουηδία"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Ταϊλάνδη"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Τουρκία"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Τσεχία"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Φινλανδία"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Χιλή"
    }
  ],
  "el-GR": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Αργεντινή"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Αυστραλία"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Αυστρία"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Βέλγιο"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Βιετνάμ"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Βουλγαρία"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Βραζιλία"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Γαλλία"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Γερμανία"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Δανία"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Ελλάδα"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Εσθονία"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Ηνωμένες Πολιτείες"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Ηνωμένο Βασίλειο"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Ιαπωνία"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Ινδία"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Ινδονησία"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ιρλανδία"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Ισλανδία"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Ισπανία"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Ιταλία"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Καναδάς"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Κάτω Χώρες"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Κίνα"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Κολομβία"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Κροατία"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Κύπρος"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Λετονία"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Λιθουανία"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Λουξεμβούργο"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Μαλαισία"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Μάλτα"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Μεξικό"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Νέα Ζηλανδία"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Νορβηγία"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Νότια Αφρική"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Νότια Κορέα"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ουγγαρία"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ουκρανία"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Πολωνία"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Πορτογαλία"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Ρουμανία"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Ρωσία"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Σλοβακία"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Σλοβενία"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Σουηδία"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Ταϊλάνδη"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Τουρκία"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Τσεχία"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Φινλανδία"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Χιλή"
    }
  ],
  "et-EE": [
    {
      "id": "US",
      "value": "US",
      "label": "Ameerika Ühendriigid"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austraalia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasiilia"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaaria"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Eesti"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Hiina"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Hispaania"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Holland"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Horvaatia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Iirimaa"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indoneesia"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itaalia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Jaapan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Kreeka"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Küpros"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Leedu"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburg"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Lõuna-Aafrika Vabariik"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Lõuna-Korea"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Läti"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaisia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mehhiko"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norra"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poola"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Prantsusmaa"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Rootsi"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumeenia"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Saksamaa"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakkia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Sloveenia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Soome"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Taani"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tai"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tšehhi"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Tšiili"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türgi"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungari"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Uus-Meremaa"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Venemaa"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Ühendkuningriik"
    }
  ],
  "fi-FI": [
    {
      "id": "NL",
      "value": "NL",
      "label": "Alankomaat"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentiina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilia"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Espanja"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Etelä-Afrikka"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Etelä-Korea"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Intia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanti"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islanti"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Iso-Britannia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Itävalta"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japani"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kiina"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbia"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Kreikka"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kypros"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Liettua"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malesia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksiko"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norja"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugali"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Puola"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Ranska"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Ruotsi"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Saksa"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Suomi"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Tanska"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaimaa"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tšekki"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkki"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Unkari"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Uusi-Seelanti"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Venäjä"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Viro"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Yhdysvallat"
    }
  ],
  "hr-HR": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australija"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austrija"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgija"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bugarska"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cipar"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Češka"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Čile"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danska"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonija"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finska"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francuska"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grčka"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Hrvatska"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indija"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonezija"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irska"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italija"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Južna Koreja"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Južnoafrička Republika"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kina"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbija"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvija"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litva"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburg"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Mađarska"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malezija"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksiko"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nizozemska"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norveška"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Novi Zeland"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Njemačka"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poljska"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumunjska"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusija"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Sjedinjene Američke Države"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovačka"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenija"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Španjolska"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Švedska"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tajland"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turska"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Ujedinjeno Kraljevstvo"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrajina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vijetnam"
    }
  ],
  "hu-HU": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentína"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Ausztrália"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Ausztria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazília"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgária"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Ciprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Csehország"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dánia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Dél-afrikai Köztársaság"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Dél-Korea"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Egyesült Államok"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Egyesült Királyság"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Észtország"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnország"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Franciaország"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Görögország"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Hollandia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Horvátország"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonézia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Írország"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Izland"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japán"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kína"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbia"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Lengyelország"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettország"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litvánia"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Magyarország"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malajzia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Málta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexikó"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Németország"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvégia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Olaszország"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Oroszország"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugália"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Románia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanyolország"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Svédország"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Szlovákia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Szlovénia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thaiföld"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Törökország"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Új-Zéland"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrajna"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnám"
    }
  ],
  "id-ID": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrika Selatan"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Amerika Serikat"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Belanda"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Ceko"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Cile"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungaria"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Inggris Raya"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlandia"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandia"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Jepang"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Jerman"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolombia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Korea Selatan"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroasia"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksiko"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegia"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polandia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Prancis"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Selandia Baru"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Siprus"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanyol"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Swedia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Tiongkok"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turki"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Yunani"
    }
  ],
  "is-IS": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentína"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austurríki"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Ástralía"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Bandaríkin"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgía"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilía"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Bretland"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Búlgaría"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danmörk"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Eistland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finnland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frakkland"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grikkland"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Holland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indland"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indónesía"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Írland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Ísland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Ítalía"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kína"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kólumbía"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Króatía"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kýpur"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litháen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Lúxemborg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malasía"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexíkó"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Noregur"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nýja-Sjáland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portúgal"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Pólland"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rúmenía"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rússland"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Síle"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slóvakía"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slóvenía"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spánn"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Suður-Afríka"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Suður-Kórea"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Svíþjóð"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Taíland"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tékkland"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Tyrkland"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungverjaland"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Úkraína"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Víetnam"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Þýskaland"
    }
  ],
  "ko-KR": [
    {
      "id": "GR",
      "value": "GR",
      "label": "그리스"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "남아프리카"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "네덜란드"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "노르웨이"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "뉴질랜드"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "대한민국"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "덴마크"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "독일"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "라트비아"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "러시아"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "루마니아"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "룩셈부르크"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "리투아니아"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "말레이시아"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "멕시코"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "몰타"
    },
    {
      "id": "US",
      "value": "US",
      "label": "미국"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "베트남"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "벨기에"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "불가리아"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "브라질"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "스웨덴"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "스페인"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "슬로바키아"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "슬로베니아"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "아르헨티나"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "아이슬란드"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "아일랜드"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "에스토니아"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "영국"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "오스트레일리아"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "오스트리아"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "우크라이나"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "이탈리아"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "인도"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "인도네시아"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "일본"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "중국"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "체코"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "칠레"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "캐나다"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "콜롬비아"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "크로아티아"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "키프로스"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "태국"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "튀르키예"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "포르투갈"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "폴란드"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "프랑스"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "핀란드"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "헝가리"
    }
  ],
  "lt-LT": [
    {
      "id": "IE",
      "value": "IE",
      "label": "Airija"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australija"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austrija"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgija"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazilija"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarija"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Čekija"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Čilė"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danija"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estija"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Graikija"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indija"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonezija"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandija"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Ispanija"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italija"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonija"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Jungtinė Karalystė"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Jungtinės Valstijos"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kinija"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kipras"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbija"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatija"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvija"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Lenkija"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lietuva"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Liuksemburgas"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaizija"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksika"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Naujoji Zelandija"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nyderlandai"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvegija"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Pietų Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Pietų Korėja"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalija"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Prancūzija"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumunija"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusija"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakija"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovėnija"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Suomija"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Švedija"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tailandas"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkija"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Vengrija"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnamas"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Vokietija"
    }
  ],
  "lv-LV": [
    {
      "id": "US",
      "value": "US",
      "label": "Amerikas Savienotās Valstis"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Apvienotā Karaliste"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentīna"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austrālija"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austrija"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Beļģija"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazīlija"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgārija"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Čehija"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Čīle"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dānija"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Dienvidāfrikas Republika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Dienvidkoreja"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francija"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grieķija"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Horvātija"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Igaunija"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indija"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonēzija"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islande"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itālija"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Īrija"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japāna"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Jaunzēlande"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanāda"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kipra"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbija"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Krievija"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Ķīna"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvija"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lietuva"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburga"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaizija"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksika"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nīderlande"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvēģija"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polija"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugāle"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumānija"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovākija"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovēnija"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Somija"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spānija"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Taizeme"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turcija"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungārija"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Vācija"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vjetnama"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Zviedrija"
    }
  ],
  "ms-MY": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Afrika Selatan"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Amerika Syarikat"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Belanda"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgium"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Denmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Greece"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Itali"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Jepun"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Jerman"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Korea Selatan"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lithuania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norway"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Perancis"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poland"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Sepanyol"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sweden"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraine"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "United Kingdom"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "no-NO": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankrike"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Hellas"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kina"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kypros"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nederland"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norge"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Russland"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spania"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Storbritannia"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sverige"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sør-Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Sør-Korea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tsjekkia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Tyrkia"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Tyskland"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungarn"
    },
    {
      "id": "US",
      "value": "US",
      "label": "USA"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Østerrike"
    }
  ],
  "pl-PL": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentyna"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazylia"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bułgaria"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Chiny"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Chorwacja"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cypr"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Czechy"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dania"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandia"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francja"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecja"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Hiszpania"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Holandia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indie"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonezja"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlandia"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonia"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Korea Południowa"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litwa"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburg"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Łotwa"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malezja"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksyk"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Niemcy"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norwegia"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nowa Zelandia"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polska"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalia"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Republika Południowej Afryki"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rosja"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumunia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Słowacja"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Słowenia"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Stany Zjednoczone"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Szwecja"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tajlandia"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turcja"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Węgry"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Wielka Brytania"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Wietnam"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Włochy"
    }
  ],
  "ro-RO": [
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Africa de Sud"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Austria"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgia"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazilia"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Cehia"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "China"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cipru"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Columbia"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Coreea de Sud"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croația"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danemarca"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlanda"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Franța"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Germania"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grecia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonezia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irlanda"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islanda"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italia"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonia"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letonia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Lituania"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexic"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norvegia"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Noua Zeelandă"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonia"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalia"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Regatul Unit"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "România"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusia"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovacia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spania"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Statele Unite ale Americii"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Suedia"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailanda"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turcia"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Țările de Jos"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ucraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungaria"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "ru-RU": [
    {
      "id": "AU",
      "value": "AU",
      "label": "Австралия"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Австрия"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Аргентина"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Бельгия"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Болгария"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Бразилия"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Великобритания"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Венгрия"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Вьетнам"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Германия"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Греция"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Дания"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Индия"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Индонезия"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ирландия"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Исландия"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Испания"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Италия"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Канада"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Кипр"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Китай"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Колумбия"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Латвия"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Литва"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Люксембург"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Малайзия"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Мальта"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Мексика"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Нидерланды"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Новая Зеландия"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Норвегия"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Польша"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Португалия"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Республика Корея"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Россия"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Румыния"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Словакия"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Словения"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Соединенные Штаты"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Таиланд"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Турция"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Украина"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Финляндия"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Франция"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Хорватия"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Чехия"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Чили"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Швеция"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Эстония"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Южно-Африканская Республика"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Япония"
    }
  ],
  "ru-UA": [
    {
      "id": "AU",
      "value": "AU",
      "label": "Австралия"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Австрия"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Аргентина"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Бельгия"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Болгария"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Бразилия"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Великобритания"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Венгрия"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Вьетнам"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Германия"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Греция"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Дания"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Индия"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Индонезия"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ирландия"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Исландия"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Испания"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Италия"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Канада"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Кипр"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Китай"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Колумбия"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Латвия"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Литва"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Люксембург"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Малайзия"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Мальта"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Мексика"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Нидерланды"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Новая Зеландия"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Норвегия"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Польша"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Португалия"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Республика Корея"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Россия"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Румыния"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Словакия"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Словения"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Соединенные Штаты"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Таиланд"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Турция"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Украина"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Финляндия"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Франция"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Хорватия"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Чехия"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Чили"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Швеция"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Эстония"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Южно-Африканская Республика"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Япония"
    }
  ],
  "sk-SK": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentína"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Austrália"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgicko"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazília"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulharsko"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cyprus"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Česko"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Čile"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Čína"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Dánsko"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estónsko"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Fínsko"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francúzsko"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grécko"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Holandsko"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Chorvátsko"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "India"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonézia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Írsko"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonsko"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Južná Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Južná Kórea"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litva"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lotyšsko"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembursko"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Maďarsko"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malajzia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Nemecko"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Nórsko"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nový Zéland"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poľsko"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalsko"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Rakúsko"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumunsko"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusko"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovensko"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovinsko"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Spojené kráľovstvo"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Spojené štáty"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Španielsko"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Švédsko"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Taliansko"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thajsko"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turecko"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrajina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    }
  ],
  "sl-SI": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Avstralija"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Avstrija"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgija"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bolgarija"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazilija"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Ciper"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Češka"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Čile"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danska"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonija"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finska"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Francija"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grčija"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Hrvaška"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indija"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonezija"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irska"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Islandija"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italija"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonska"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Južna Koreja"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Južnoafriška republika"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kitajska"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolumbija"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvija"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litva"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luksemburg"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Madžarska"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malezija"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mehika"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Nemčija"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nizozemska"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norveška"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nova Zelandija"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Poljska"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugalska"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romunija"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusija"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovaška"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenija"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Španija"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Švedska"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tajska"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turčija"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrajina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Združene države Amerike"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Združeno kraljestvo"
    }
  ],
  "sv-SE": [
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australien"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belgien"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brasilien"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgarien"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Cypern"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danmark"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estland"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finland"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Frankrike"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Grekland"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Indien"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesien"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Irland"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Island"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italien"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japan"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Kina"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Kroatien"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Lettland"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litauen"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxemburg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexiko"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Nederländerna"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norge"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Nya Zeeland"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polen"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portugal"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Rumänien"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Ryssland"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakien"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenien"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Spanien"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Storbritannien"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Sverige"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Sydafrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Sydkorea"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thailand"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Tjeckien"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Turkiet"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Tyskland"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Ungern"
    },
    {
      "id": "US",
      "value": "US",
      "label": "USA"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Österrike"
    }
  ],
  "th-TH": [
    {
      "id": "GR",
      "value": "GR",
      "label": "กรีซ"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "เกาหลีใต้"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "แคนาดา"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "โครเอเชีย"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "โคลอมเบีย"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "จีน"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "ชิลี"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "เช็ก"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "ไซปรัส"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "ญี่ปุ่น"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "เดนมาร์ก"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "ตุรกี"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "ไทย"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "นอร์เวย์"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "นิวซีแลนด์"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "เนเธอร์แลนด์"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "บราซิล"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "บัลแกเรีย"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "เบลเยียม"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "โปรตุเกส"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "โปแลนด์"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "ฝรั่งเศส"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "ฟินแลนด์"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "มอลตา"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "มาเลเซีย"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "เม็กซิโก"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "ยูเครน"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "เยอรมนี"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "รัสเซีย"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "โรมาเนีย"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "ลักเซมเบิร์ก"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "ลัตเวีย"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "ลิทัวเนีย"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "เวียดนาม"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "สเปน"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "สโลวะเกีย"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "สโลวีเนีย"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "สวีเดน"
    },
    {
      "id": "US",
      "value": "US",
      "label": "สหรัฐอเมริกา"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "สหราชอาณาจักร"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "ออสเตรเลีย"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "ออสเตรีย"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "อาร์เจนตินา"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "อิตาลี"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "อินเดีย"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "อินโดนีเซีย"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "เอสโตเนีย"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "แอฟริกาใต้"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "ไอซ์แลนด์"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "ไอร์แลนด์"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "ฮังการี"
    }
  ],
  "tr-TR": [
    {
      "id": "DE",
      "value": "DE",
      "label": "Almanya"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Amerika Birleşik Devletleri"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Arjantin"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Avustralya"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "Avusturya"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Belçika"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Birleşik Krallık"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brezilya"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaristan"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Çekya"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Çin"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Danimarka"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Endonezya"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonya"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Finlandiya"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Fransa"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Güney Afrika"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Güney Kore"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Hırvatistan"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Hindistan"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Hollanda"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "İrlanda"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "İspanya"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "İsveç"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "İtalya"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "İzlanda"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Japonya"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Kanada"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Kıbrıs"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Kolombiya"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Letonya"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litvanya"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Lüksemburg"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Macaristan"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malezya"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Meksika"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Norveç"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Polonya"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Portekiz"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romanya"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Rusya"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakya"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenya"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Şili"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Tayland"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Türkiye"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukrayna"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Vietnam"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "Yeni Zelanda"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Yunanistan"
    }
  ],
  "vi-VN": [
    {
      "id": "AT",
      "value": "AT",
      "label": "Áo"
    },
    {
      "id": "AR",
      "value": "AR",
      "label": "Argentina"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "Australia"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "Ấn Độ"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "Ba Lan"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "Bỉ"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "Bồ Đào Nha"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "Brazil"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "Bulgaria"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "Canada"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "Chile"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "Colombia"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "Croatia"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "Đan Mạch"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "Đức"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "Estonia"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "Hà Lan"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "Hàn Quốc"
    },
    {
      "id": "US",
      "value": "US",
      "label": "Hoa Kỳ"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "Hungary"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "Hy Lạp"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "Iceland"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "Indonesia"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "Ireland"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "Italy"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "Latvia"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "Litva"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "Luxembourg"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "Malaysia"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "Malta"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "Mexico"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "Na Uy"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "Nam Phi"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "New Zealand"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "Nga"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "Nhật Bản"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "Pháp"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "Phần Lan"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "Romania"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "Séc"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "Síp"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "Slovakia"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "Slovenia"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "Tây Ban Nha"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "Thái Lan"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "Thổ Nhĩ Kỳ"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "Thụy Điển"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "Trung Quốc"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "Ukraina"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "Việt Nam"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "Vương quốc Anh"
    }
  ],
  "zh-CN": [
    {
      "id": "AR",
      "value": "AR",
      "label": "阿根廷"
    },
    {
      "id": "IE",
      "value": "IE",
      "label": "爱尔兰"
    },
    {
      "id": "EE",
      "value": "EE",
      "label": "爱沙尼亚"
    },
    {
      "id": "AT",
      "value": "AT",
      "label": "奥地利"
    },
    {
      "id": "AU",
      "value": "AU",
      "label": "澳大利亚"
    },
    {
      "id": "BR",
      "value": "BR",
      "label": "巴西"
    },
    {
      "id": "BG",
      "value": "BG",
      "label": "保加利亚"
    },
    {
      "id": "BE",
      "value": "BE",
      "label": "比利时"
    },
    {
      "id": "IS",
      "value": "IS",
      "label": "冰岛"
    },
    {
      "id": "PL",
      "value": "PL",
      "label": "波兰"
    },
    {
      "id": "DK",
      "value": "DK",
      "label": "丹麦"
    },
    {
      "id": "DE",
      "value": "DE",
      "label": "德国"
    },
    {
      "id": "RU",
      "value": "RU",
      "label": "俄罗斯"
    },
    {
      "id": "FR",
      "value": "FR",
      "label": "法国"
    },
    {
      "id": "FI",
      "value": "FI",
      "label": "芬兰"
    },
    {
      "id": "CO",
      "value": "CO",
      "label": "哥伦比亚"
    },
    {
      "id": "KR",
      "value": "KR",
      "label": "韩国"
    },
    {
      "id": "NL",
      "value": "NL",
      "label": "荷兰"
    },
    {
      "id": "CA",
      "value": "CA",
      "label": "加拿大"
    },
    {
      "id": "CZ",
      "value": "CZ",
      "label": "捷克"
    },
    {
      "id": "HR",
      "value": "HR",
      "label": "克罗地亚"
    },
    {
      "id": "LV",
      "value": "LV",
      "label": "拉脱维亚"
    },
    {
      "id": "LT",
      "value": "LT",
      "label": "立陶宛"
    },
    {
      "id": "LU",
      "value": "LU",
      "label": "卢森堡"
    },
    {
      "id": "RO",
      "value": "RO",
      "label": "罗马尼亚"
    },
    {
      "id": "MT",
      "value": "MT",
      "label": "马耳他"
    },
    {
      "id": "MY",
      "value": "MY",
      "label": "马来西亚"
    },
    {
      "id": "US",
      "value": "US",
      "label": "美国"
    },
    {
      "id": "MX",
      "value": "MX",
      "label": "墨西哥"
    },
    {
      "id": "ZA",
      "value": "ZA",
      "label": "南非"
    },
    {
      "id": "NO",
      "value": "NO",
      "label": "挪威"
    },
    {
      "id": "PT",
      "value": "PT",
      "label": "葡萄牙"
    },
    {
      "id": "JP",
      "value": "JP",
      "label": "日本"
    },
    {
      "id": "SE",
      "value": "SE",
      "label": "瑞典"
    },
    {
      "id": "CY",
      "value": "CY",
      "label": "塞浦路斯"
    },
    {
      "id": "SK",
      "value": "SK",
      "label": "斯洛伐克"
    },
    {
      "id": "SI",
      "value": "SI",
      "label": "斯洛文尼亚"
    },
    {
      "id": "TH",
      "value": "TH",
      "label": "泰国"
    },
    {
      "id": "TR",
      "value": "TR",
      "label": "土耳其"
    },
    {
      "id": "UA",
      "value": "UA",
      "label": "乌克兰"
    },
    {
      "id": "ES",
      "value": "ES",
      "label": "西班牙"
    },
    {
      "id": "GR",
      "value": "GR",
      "label": "希腊"
    },
    {
      "id": "NZ",
      "value": "NZ",
      "label": "新西兰"
    },
    {
      "id": "HU",
      "value": "HU",
      "label": "匈牙利"
    },
    {
      "id": "IT",
      "value": "IT",
      "label": "意大利"
    },
    {
      "id": "IN",
      "value": "IN",
      "label": "印度"
    },
    {
      "id": "ID",
      "value": "ID",
      "label": "印度尼西亚"
    },
    {
      "id": "GB",
      "value": "GB",
      "label": "英国"
    },
    {
      "id": "VN",
      "value": "VN",
      "label": "越南"
    },
    {
      "id": "CL",
      "value": "CL",
      "label": "智利"
    },
    {
      "id": "CN",
      "value": "CN",
      "label": "中国"
    }
  ]
}
